import React from "react";
import { Menu, Avatar } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";

const RightMenuAdmin = (props) => {
    return (
        <Menu mode={props.mode} className="menuContent">
            <Menu.SubMenu
                style={{ backgroundColor: 'white', color: '#012E40' }}
                title={
                    <>
                        <Avatar icon={<UserOutlined />} />
                        <span className="username">John Doe</span>
                    </>
                }
            >
                <Menu.Item key="change-pass" onClick={props.openChangePassword}>
                    <UserOutlined /> Cambiar Contraseña
                </Menu.Item>
                <Menu.Item key="log-out" onClick={props.logout}>
                    <LogoutOutlined /> Cerrar Sesión
                </Menu.Item>
            </Menu.SubMenu>
        </Menu>
    );
};

export default RightMenuAdmin;